<nz-tree
#nzTreeComponent
nzVirtualHeight="500px"
[nzData]="nodes"
[nzCheckStrictly]="nzCheckStrictly"
nzCheckable
[nzCheckedKeys]="defaultCheckedKeys"
[nzExpandedKeys]="defaultExpandedKeys"
[nzSelectedKeys]="defaultSelectedKeys"
(nzCheckBoxChange)="nzCheck($event)"
>
</nz-tree>
